module.exports = __webpack_public_path__ + "img/datos.ec509fc6.svg";